var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsArmour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.410156L13.1941 0.630547C9.6201 3.22438 6.10272 4.92461 0.732056 5.78867L0.307251 5.8543V6.26992C0.307251 7.30899 0.783032 8.9332 1.55901 10.9238C2.32932 12.9199 3.41682 15.2332 4.67538 17.4426C5.93846 19.652 7.36014 21.7574 8.85545 23.3324C10.3338 24.9129 11.8857 26.0066 13.5 26.0066C15.1142 26.0066 16.6662 24.9129 18.1558 23.3324C19.6398 21.7574 21.0615 19.652 22.3303 17.4426C23.5877 15.2332 24.6695 12.9199 25.4455 10.9238C26.2158 8.9332 26.6916 7.30899 26.6916 6.26992V5.8543L26.2724 5.78867C20.9142 4.92461 17.3855 3.22438 13.8058 0.630547L13.5 0.410156ZM13.5 1.62422C16.9607 4.08734 20.5461 5.78867 25.6437 6.67461C25.5361 7.50586 25.134 8.93867 24.4939 10.5848C24.2617 11.1754 24.0068 11.7988 23.718 12.4441H15.3125V9.76992L18.9375 10.6449L13.5 4.52211L8.06249 10.6449L11.6875 9.76992V12.4441H3.28032C2.99711 11.7988 2.73713 11.1754 2.50491 10.5848C1.87053 8.93867 1.46272 7.50586 1.3551 6.67461C6.45389 5.78867 10.0336 4.08734 13.5 1.62422Z",
    fill: "#ADACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArmour);
export default __webpack_public_path__ + "static/media/icons_armour.219735229ba86ad06739f1934f159639.svg";
export { ForwardRef as ReactComponent };